import { render, staticRenderFns } from "./ModalChannelSelect.vue?vue&type=template&id=047e62bf&scoped=true&"
import script from "./ModalChannelSelect.vue?vue&type=script&lang=ts&"
export * from "./ModalChannelSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ModalChannelSelect.vue?vue&type=style&index=0&id=047e62bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e62bf",
  null
  
)

export default component.exports